import { Injectable } from '@angular/core';
import { RepositoryBase } from '@asm/features/sync/repositories/repository-base';
import { T685 } from '@asm/features/sync/models/pricing-tables.model';

@Injectable({ providedIn: 'root' })
export class T685Repository extends RepositoryBase<T685> {
  protected readonly KEY_PATH = 't685';
}
